__turbopack_context__.v({
  "container": "styles-module-scss-module__AAMaAW__container",
});
